import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface TallyDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function TallyDialog({ open, onOpenChange }: TallyDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] p-0 overflow-hidden">
        <DialogHeader className="p-6 pb-2">
          <DialogTitle className="text-2xl">Schedule Your Demo</DialogTitle>
          <DialogDescription>
            Fill out the form below and we'll get back to you with next steps.
          </DialogDescription>
        </DialogHeader>
        <div className="overflow-y-auto px-6 pb-6">
          {open && (
            <iframe
              src="https://tally.so/embed/44rjQd?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
              width="100%"
              height="500"
              frameBorder="0"
              marginHeight={0}
              marginWidth={0}
              title="Schedule a Demo with JobWalk AI"
              className="w-full"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
